export default __webpack_public_path__ + "static/logo-simvent-8098e6e6c823ce53b23ecbf25a1d156d.png";